import React, { useState, useEffect } from 'react';

import type { Option, Props as SelectProps } from 'Elements/Input/Select';
import VisuallyHidden from 'Elements/VisuallyHidden';
import Label from 'Elements/Label';
import ArrowButton, { ArrowLinkButtonProps } from 'Elements/Button/Arrow';
import ArrowLink from 'Elements/Link/Arrow';

import VariantSelect from './subcomponents/VariantSelect';

import {
    Container,
    ApplyContainer,
    InputContainer,
    OpenDayContainer,
    HeadingApplication,
    HeadingOpenDay
} from './CourseApply.styled';

interface LinkOption extends Option {
    link: ArrowLinkButtonProps;
}
interface SelectWithLinkOption extends SelectProps {
    options: LinkOption[];
}

export interface Props {
    select: SelectWithLinkOption;
    apply: {
        heading: string;
    };
    openDay: {
        heading: string;
        link: ArrowLinkButtonProps;
    };
}

const CourseApply: React.FC<Props> = props => {
    const { apply, openDay, select } = props;
    const [value, setValue] = useState<string | null>();
    const [links, setLinks] = useState<Record<string, ArrowLinkButtonProps> | null>(null);

    useEffect(() => {
        const links = {};

        select.options.forEach(option => (links[option.value] = option.link));

        setLinks(links);
    }, [select]);

    return (
        <Container>
            <ApplyContainer>
                <HeadingApplication>{apply.heading}</HeadingApplication>
                <InputContainer>
                    <VisuallyHidden>
                        <Label id="variant-label" htmlFor="course-apply">
                            Choose course variant
                        </Label>
                    </VisuallyHidden>
                    <VariantSelect
                        {...select}
                        handleValueChange={value => setValue(value)}
                        aria-labelledby="variant-label"
                    />
                    {links && value && (
                        <ArrowButton
                            {...links[value]}
                            id="application-apply"
                            variant="accentFive"
                        />
                    )}
                </InputContainer>
            </ApplyContainer>
            <OpenDayContainer>
                <HeadingOpenDay>{openDay.heading}</HeadingOpenDay>
                <ArrowLink {...openDay.link} variant="secondaryFive" />
            </OpenDayContainer>
        </Container>
    );
};

export default CourseApply;
